import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AlertClassEnum } from '@app/shared/enums/alert-class.enum';

@Component({
  selector: 'a360-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ConfirmationModalComponent {
  public confirm;
  public reject;
  public title;
  public text;
  public textBold;
  public textMultiLine;
  public closeText;
  public confirmText;
  public isWarningConfirmBtn;
  public alwaysTrue = false;
  public textHtml: string;
  public alertText: string;
  public alertStyle: AlertClassEnum;

  @Output()
  public confirmation: EventEmitter<boolean>;

  constructor(public bsModalRef: BsModalRef) {
    this.confirmation = new EventEmitter<boolean>();
  }

  public onReject(): void {
    this.bsModalRef.hide();
    if (this.reject && typeof this.reject === 'function') {
      this.reject();
    }

    this.confirmation.emit(this.alwaysTrue);
  }

  public onConfirm(): void {
    this.bsModalRef.hide();

    if (this.confirm && typeof this.confirm === 'function') {
      this.confirm();
    }

    this.confirmation.emit(true);
  }
}
